export default () => ({
  fields: [] as { id: number }[],

  addNewField() {
    this.fields.push({ id: new Date().getTime() + this.fields.length });
  },

  removeField(field: { id: number } | string) {
    if (typeof field === "string") {
      const ele = document.querySelector(`#${field}`);
      if (ele?.parentNode) {
        (ele.parentNode as HTMLElement).remove();
      }
    } else {
      this.fields.splice(this.fields.indexOf(field), 1);
    }
  },
});
